import React, {useContext, useEffect, useState} from 'react';

import AuthContext from "../Validation/AuthContext";
import VariableItem from "./VariableItem";

const GlobalVariables = () => {

    const [OptionVal, setOptionVal] = useState("integer")

    const [name, setName] = useState("")
    const [variables, setVariables] = useState([])
    const [qq, setQQ] = useState(true)


    useEffect(() => {

        try {
            const varibls = localStorage.getItem("variables")
            if (varibls !== null)
                setVariables(JSON.parse(varibls))
        } catch (e) {

        }
        // setVariables(JSON.parse(varibls))
    }, [qq])

    const onClick = (event) => {
        if (event)
            event.preventDefault()

        if (name != "") {
            let isEquil = false
            for (const variable of variables) {
                if (variable.name === name) {
                    isEquil = true
                }
            }

            if (!isEquil) {
                const value = variables
                value.push({name: name, type: OptionVal})
                localStorage.setItem("variables", JSON.stringify(value))
                setQQ(!qq)
                setName("")
            }

        }
    }

    const removeVar = (name) => {

        let arr = []
        for (const varib of variables) {
            if (varib.name !== name) {
                arr.push(varib)
            }
        }
        localStorage.setItem("variables", JSON.stringify(arr))
        setQQ(!qq)


    }

    // const fetch = async ()=>{
    //     const variables = await api.getAllVariables({userId: ID, projectId: window.location.pathname.slice(1)})
    //
    //     setVariables(variables.variables)
    // }
    //
    // useEffect(()=>{
    //     //fetch()
    //
    //
    //
    // },[])


    return (
        <>
            <div className="gloabalVarLabel">Variables</div>
            <div className="globalVariables">

                {variables && variables.map((value) =>
                    <VariableItem name={value.name} removeVar={removeVar} type={value.type} key={value.name}
                                  typeOfComponent={"variable"}
                    />)}

            </div>
            <div className="createVarForm">
                {/*{isVisible &&  <>*/}
                <input className="GlobalInput inpGlob"
                       onKeyDown={(event) => {
                           if (event.key === "Enter") {
                               onClick()
                           }
                       }}
                       onChange={(e) => setName(e.target.value)} value={name} placeholder="Name"
                />
                <select onChange={(eve) => {
                    setOptionVal(eve.target.value)
                }}
                        style={{borderRadius: 0, background: "gray", color: "whitesmoke", fontWeight: "bold"}}
                        className="GlobalInput"
                >
                    <option value="integer">Integer</option>
                    <option value="float">Float</option>
                    <option value="bool">Bool</option>
                    <option value="string">String</option>
                </select>

                <button onClick={onClick} className="ButtonGlobal">Add</button>
            </div>


            {/*{OptionVal === "float" && <input type="number" step='0.1' placeholder="Initial value" onChange={(e)=>setFloat(parseFloat(e.target.value))}/>}*/}
            {/*{OptionVal === "integer" && <input type="number" step="1"   placeholder="Initial value" onChange={(e)=>setIntager(parseInt(e.target.value))}/>}*/}
            {/*{OptionVal === "string" && <input placeholder="Initial value" onChange={(e)=>setString(e.target.value)}/>}*/}
            {/*{  OptionVal === "bool" &&  <select  defaultValue="true" onChange={(e)=>setBool(e.target.value === 'true')}>*/}
            {/*    <option value="true">True</option>*/}
            {/*    <option value="false">False</option>*/}
            {/*</select>}*/}


        </>

    );
};

export default GlobalVariables;